import Axios from '@backoffice/services/Axios'
import { AnyConstructor, Mixin } from '@backoffice/types/api'

type AxiosType = typeof Axios

function CookieManageMixin<TBase extends AnyConstructor>(Base: TBase & AxiosType) {
  return class CookieManage extends Base {
    updateCookiePermission = (): Promise<void> =>
      this.post('api/cookie_permission', {
        headers: {
          'Content-Type': 'text/html',
          Accept: '*/*',
          'Access-Control-Allow-Origin': '*',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
  }
}

export type CookieManageMixinType = Mixin<typeof CookieManageMixin>

export default CookieManageMixin
